export default __webpack_public_path__ + "static/media/CK-LOGO-Animated.1c4029c0.svg";